const { userAgent } = navigator;
// 判断浏览器版本
const isOpera = userAgent.indexOf('Opera') > -1; // 判断是否Opera浏览器
const isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera; // 判断是否IE浏览器
const isEdge = userAgent.toLowerCase().indexOf('edge') > -1 && !isIE; // 判断是否IE的Edge浏览器
const isIE11 = userAgent.toLowerCase().indexOf('trident') > -1 && userAgent.indexOf('rv') > -1;

function getBroswerAndVersion() {
  let info = '';
  let tempArray = '';

  if (/[Ff]irefox(\/\d+\.\d+)/.test(userAgent)) {
    tempArray = /([Ff]irefox)\/(\d+\.\d+)/.exec(userAgent);
    info += tempArray[1] + tempArray[2];
  } else if (isIE) {
    let version = '';
    const reIE = new RegExp('MSIE (\\d+\\.\\d+);');
    reIE.test(userAgent);
    const fIEVersion = parseFloat(RegExp.$1);
    version = `IE${fIEVersion}`;

    info += version;
  } else if (isEdge) {
    info += 'Edge';
  } else if (isIE11) {
    info += 'IE11';
  } else if (/[Cc]hrome\/\d+/.test(userAgent)) {
    tempArray = /([Cc]hrome)\/(\d+)/.exec(userAgent);
    info += tempArray[1] + tempArray[2];
  } else if (/[Vv]ersion\/\d+\.\d+\.\d+(\.\d)* *[Ss]afari/.test(userAgent)) {
    tempArray = /[Vv]ersion\/(\d+\.\d+\.\d+)(\.\d)* *([Ss]afari)/.exec(userAgent);
    info += tempArray[3] + tempArray[1];
  } else if (/[Oo]pera.+[Vv]ersion\/\d+\.\d+/.test(userAgent)) {
    tempArray = /([Oo]pera).+[Vv]ersion\/(\d+)\.\d+/.exec(userAgent);
    info += tempArray[1] + tempArray[2];
  } else {
    info += 'unknown';
  }

  return info;
}

function isIEBroswer() {
  return isIE || isIE11;
}

export { getBroswerAndVersion, isIEBroswer };
